import { Mail, Phone, MapPin, Globe } from 'lucide-react';

interface FooterProps {
  onPageChange: (page: string) => void;
}

export function Footer({ onPageChange }: FooterProps) {
  const quickLinks = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About Us' },
    { id: 'products', label: 'Products' },
    { id: 'services', label: 'Services' },
    { id: 'contact', label: 'Contact Us' }
  ];

  const services = [
    'Global Trading',
    'Quality Inspection',
    'Logistics & Shipping',
    'Documentation',
    'Customer Support',
    'Consultation'
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr_1fr] gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <button 
                onClick={() => onPageChange('home')}
                className="cursor-pointer hover:opacity-80 transition-opacity duration-300 flex flex-col md:flex-row md:items-center gap-3"
              >
                <img 
                  src="/assets/icons/logo-w.svg" 
                  alt="Double Click Trading FZE Logo" 
                  className="h-20 w-auto"
                />
                <span className="text-xl font-bold text-white">DOUBLE CLICK TRADING FZE</span>
              </button>
            </div>
            <p className="text-gray-300 mb-6">
              A leading scrap trading company, proudly serving global markets since 2020
            </p>
            <div className="space-y-2">
              <div className="flex items-start text-sm">
                <MapPin className="w-4 h-4 mr-2 mt-0.5 text-[#ffc533] flex-shrink-0" />
                <span>Office - C1 - 1F - SF0864, Ajman Free Zone C1 Building, Dubai, UAE</span>
              </div>
              <a href="tel:+971543643476" className="flex items-center text-sm hover:text-[#ffc533] transition-colors">
                <Phone className="w-4 h-4 mr-2 text-[#ffc533]" />
                <span>+971 54 364 3476</span>
              </a>
              <a href="mailto:info@doubleclickfze.com" className="flex items-center text-sm hover:text-[#ffc533] transition-colors">
                <Mail className="w-4 h-4 mr-2 text-[#ffc533]" />
                <span>info@doubleclickfze.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => onPageChange(link.id)}
                    className="text-gray-300 hover:text-[#ffc533] transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Services</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <button
                    onClick={() => onPageChange('services')}
                    className="text-gray-300 hover:text-[#ffc533] transition-colors"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 DOUBLE CLICK TRADING FZE. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <span>Established 2020</span>
              <span>•</span>
              <span>Dubai, UAE</span>
              <span>•</span>
              <div className="flex items-center">
                <Globe className="w-4 h-4 mr-1" />
                <span>Global Trading</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}